module.exports = __webpack_public_path__ + "img/versovendas.7bde2a8b.png";